import logo from "../../../../assets/images/logo.svg";
import loginLeftBg from "../../../../assets/images/login-left-section.svg";

export function AuthBrandPanel() {
  return (
    <aside className="relative h-full w-full overflow-hidden bg-bgLight">
      <img
        src={loginLeftBg}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="relative flex h-full items-center justify-center">
        <img src={logo} alt="Procurtal" className="w-[60%] max-w-[380px]" />
      </div>
    </aside>
  );
}

export default AuthBrandPanel;
